import { useState } from 'react'
import { METRIC_TAG } from '../../../../../model/caf.interface'
import { useCafAnalysisComponentDetailListV5 } from '../../../../../modules/apis/webview/caf'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import ComplexityVocabRangeGraph from '../../charts/ComplexityVocabRangeGraph'
import WideRectangleTabs from '../../common/WideRectangleTabs'
import AccordionContainer from '../../highlight/AccordionContainer'
import ComplexityCompoundAccordion from './ComplexityCompoundAccordion'
import ComplexityMTLDAccordion from './ComplexityMTLDAccordion'
import ComplexityVocaAccordion from './ComplexityVocaAccordion'

export const tabListMap = {
  [METRIC_TAG.vocab_range]: {
    title: n_caf.complexity.tab1,
    value: METRIC_TAG.vocab_range,
  },
  [METRIC_TAG.sentence_structure]: {
    title: n_caf.complexity.tab2,
    value: METRIC_TAG.sentence_structure,
  },
  [METRIC_TAG.mtld]: {
    title: n_caf.complexity.tab3,
    value: METRIC_TAG.mtld,
  },
  [404]: {
    title: '',
    subtitle: '',
    value: '',
  },
}

const ComplexityTabsSection = ({ componentId }) => {
  const { t } = useTranslation()
  const { data, isLoading } = useCafAnalysisComponentDetailListV5(componentId)
  const [activeIndex, setActiveIndex] = useState(METRIC_TAG.vocab_range)
  if (isLoading || !data)
    return (
      <div className="flex h-[100px] w-screen items-center justify-center">
        <LoadingSpinner show primary />
      </div>
    )
  return (
    <>
      <div className="text-h5 mb-[16px]">{t(n_caf.complexity.metric)}</div>
      <WideRectangleTabs
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        tabList={data.metrics.map((mtrItem) => tabListMap[mtrItem.metric_tag])}
      />
      {/* TAB PANEL SECTION */}
      <ComplexityTabPanel activeIndex={activeIndex} graphData={data?.metrics[activeIndex]?.graph_data?.data} />
      <AccordionContainer>
        {activeIndex === METRIC_TAG.vocab_range && (
          <p className="mb-[8px] text-[12px]  text-gray-500">{t(n_caf.complexity.vocab_detail)}</p>
        )}
        <ComplexityAccordionProducts data={data} activeIndex={activeIndex} />
      </AccordionContainer>
    </>
  )
}

export const ComplexityAccordionProducts = ({ data, activeIndex }) => {
  const products = {
    [METRIC_TAG.vocab_range]: <ComplexityVocaAccordion data={data.metrics[activeIndex] as any} />,
    [METRIC_TAG.sentence_structure]: <ComplexityCompoundAccordion data={data.metrics[activeIndex] as any} />,
    [METRIC_TAG.mtld]: <ComplexityMTLDAccordion data={data.metrics[activeIndex] as any} />,
  }
  return products[activeIndex] || null
}

export const ComplexityTabPanel = ({ activeIndex, graphData }) => {
  const { t } = useTranslation()
  const products = {
    [METRIC_TAG.vocab_range]: <TabBody title={t(n_caf.complexity.tab1)} graphData={graphData} indexBy={'difficulty'} />,
    [METRIC_TAG.sentence_structure]: (
      <TabBody title={t(n_caf.complexity.tab2)} graphData={graphData} indexBy={'type'} />
    ),
    [METRIC_TAG.mtld]: null,
  }

  return products[activeIndex]
}

const TabBody = ({ title = null, graphData, indexBy }) => {
  const isMobile = useIsMobile()
  if (!graphData) return null
  if (isMobile) {
    return (
      <section className="py-[24px]">
        <article className="mb-[12px]">
          <ComplexityVocabRangeGraph data={graphData} indexBy={indexBy} title={title} />
        </article>
      </section>
    )
  } else {
    return (
      <section>
        <article className="mb-[12px]">
          <ComplexityVocabRangeGraph data={graphData} indexBy={indexBy} title={title} />
        </article>
      </section>
    )
  }
}

export default ComplexityTabsSection
